'use strict';

/**
 * Trigger analytics
 *
 * This sends an event to datalayer on element click.
 * All element data attributes are added to the event object.
 *
 * @example
 * <a href="#" class="js-trigger-analytics" data-event="dlToAnalytics" data-event-name="productLinkClick" data-product="IF-1300">Click me</a>
 *
 * results in window.dataLayer push:
 * {
 *  event: 'dlToAnalytics',
 *  eventName: 'productLinkClick',
 *  product: 'IF-1300'
 * }
 *
 */
const triggerAnalytics = {
  init: function(elements: NodeListOf<HTMLElement>) {
    console.log('triggerAnalytics.init()');
    const triggersClicked: {[key:string]: boolean} = {};

    for(let trigger of elements) {
      // Check that event and eventName are set
      if (trigger.dataset.event && trigger.dataset.eventName && window.dataLayer) {
        trigger.addEventListener('click', () => {
          if (trigger.dataset.eventName && !triggersClicked[trigger.dataset.eventName]) {

            const conversionObj = {};
            for (let key in trigger.dataset) {
              conversionObj[key] = trigger.dataset[key];
            }

            const isAdmin = document.body.classList.contains('view-admin-editor');
            if (!isAdmin) {
              window.dataLayer.push(conversionObj);
            } else {
              console.log(`triggerAnalytics: ${JSON.stringify(conversionObj, null, 2)}`);
            }
            triggersClicked[trigger.dataset.eventName] = true;
          }
        });
      }
    }
  }
}

export default triggerAnalytics;
